import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography, Box, Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useProductDocumentStyles } from './styles';
import { schema } from '../../../validation/schema';
import AppInput from '../../../../../common/AppInput';
import Buttons from '../../../../mis-datos/components/common/Buttons';
import documentFront from '../../../../../../assets/exchange/document-front.svg';
import documentBack from '../../../../../../assets/exchange/document-back.svg';
import {
  setOpenProductModal,
  getCustomerPoints,
  createCustomerExchange,
  getCustomerExchange,
} from '../../../../../../redux/actions/BankActions';

const ProductCardDocument = ({ ...props }) => {
  const { mobile, handleProductSelected } = props;

  const dispatch = useDispatch();
  const classes = useProductDocumentStyles(props);

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [documentNumber, setDocumentNumber] = useState('');

  const { newExchangeStatus } = useSelector((state) => state.bankReducer);

  const handleValidation = (event) => {
    setDocumentNumber(event.target.value);

    const result = schema.validate({ documentNumber: event.target.value });
    if ('error' in result) {
      setErrorMessage(result.error.message);
      setError(true);
      setSuccess(false);
    } else {
      setErrorMessage('');
      setError(false);
      setSuccess(true);
    }
  };

  const handleReset = () => {
    setDocumentNumber('');
    setSuccess(false);
    setError(false);
    handleProductSelected(false);
  };

  const handleSendClick = async () => {
    await dispatch(createCustomerExchange(documentNumber));
  };

  useEffect(() => {
    if (newExchangeStatus === 'succeded') {
      dispatch(getCustomerPoints());
      dispatch(getCustomerExchange());
      dispatch(setOpenProductModal(true));
    }
  }, [newExchangeStatus]);

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
      className={classes.container}
    >
      <Grid item className={classes.containerGrid}>
        <Typography className={classes.title}>
          Ingresa el número de documento de tu cédula de indentidad
        </Typography>
        <Box display="flex" alignItems="center" flexDirection="row">
          <Grid container spacing={2}>
            <Grid item md={6} xs={6}>
              <img
                data-cy="documentBack"
                src={documentBack}
                className={classes.documentImage}
                alt="Parte de trasera de la cédula de indentidad"
              />
            </Grid>
            <Grid item md={6} xs={6}>
              <img
                data-cy="documentFront"
                src={documentFront}
                className={classes.documentImage}
                alt="Parte de delantera de la cédula de indentidad"
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid item className={classes.itemInput}>
        <AppInput
          name="DocumentNumber"
          helperText="Sin puntos"
          label="N° del documento"
          required
          inputAdornment=""
          error={error}
          errorMessage={errorMessage}
          success={success}
          value={documentNumber}
          disabled={status === 'succeded'}
          onChange={handleValidation}
          onBlur={handleValidation}
          onClick={() => {}}
        />
      </Grid>
      <Grid item>
        <Buttons
          disabled={!documentNumber}
          modifiable={true}
          loading={newExchangeStatus === 'loading'}
          error={error}
          onCancelClick={handleReset}
          onSendClick={handleSendClick}
          mobile={mobile}
          primaryButtonText={'Canjear'}
          marginRightButton={20}
        />
      </Grid>
    </Box>
  );
};

ProductCardDocument.propTypes = {
  mobile: PropTypes.bool,
  handleProductSelected: PropTypes.func,
};

export default ProductCardDocument;
